export enum chargeBearer {
  customer = "customer",
  merchant = "merchant",
}
